export default "__VITE_ASSET__f662fbc3__"